// Local structural type: @yuno-payments/sdk-web-types does not declare the
// THREE_D_SECURE_* members of ContinuePaymentResponse yet (CORECM-17780).
type ContinuePaymentResult =
  | {
      action?: string
      type?: string
      redirect_url?: unknown
    }
  | null
  | undefined

// REDIRECT_URL / THREE_D_SECURE_REDIRECT_URL: the SDK navigates right after resolving.
// THREE_D_SECURE_SETUP: two-hop 3DS — a detached re-evaluation follows; the loader
// hand-off ends via paymentResult (status) or the PAYMENT_RETRY onLoading event.
const HOLD_LOADER_ACTIONS = [
  'REDIRECT_URL',
  'THREE_D_SECURE_REDIRECT_URL',
  'THREE_D_SECURE_SETUP',
]

export const shouldHoldLoader = (result: ContinuePaymentResult): boolean => {
  if (!result?.action) return false
  // The open_external_browser result carries redirect_url and does NOT navigate:
  // holding the loader for it would leave it stuck on screen.
  if (result.redirect_url) return false
  return HOLD_LOADER_ACTIONS.includes(result.action)
}
